<!--
* Provides a select field with options generated from an array of objects
*
* @param {Array[Number]} [selected=null] - Array of selected option indexes (null is the default option)
*
* @param {string} [placeholder=''] - Placeholder text to be used as the
*                                    first option (null)
* @param {Boolean} [hasPlaceholder=true] - if true then placeholder has default style 
*                                    (so it's part of the UI)
*
* @param {string} [nameKey='name'] - Which key should be used to determine
*                                         the value that should be shown
*                                         in the option, only applicable when
*                                         `this.options` is an array of objects
* @param {string} [valueKey='name'] - Which key should be used to determine
*                                         the value that should be declared in values
*                                         in the option
*
* @param {Array} [options=[]] -An array of objects used to populate the options
*
*
-->
<template>
  <div>
    <div class="">
       <multiselect  
        class="select app_select_multiple is-fullwidth"
        :class="{'placeholder': hasPlaceholder === true}"
        v-model="value" 
        :placeholder="placeholder" 
        :label="nameKey" 
        :track-by="valueKey" 
        :options="options"
        :searchable="false"
        :select-label="''"
        :selected-label="''"
        :deselect-label="''"
        :clear-on-select="false" 
        :close-on-select="false"
        :show-no-options="false"
        :multiple="true"
        @input="onChange" >
       </multiselect>
    </div>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
export default {
  name: 'AppSelectMultiple',
  components: { Multiselect },
  model: {
    prop: 'selected',
    event: 'change'
  },

  props: {
    selected: {
      type: Array,
      default: null
    },
    hasPlaceholder: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: null
    },
    nameKey: {
      type: String,
      default: 'name'
    },
    valueKey: {
      type: String,
      default: 'value'
    },
    options: {
      type: Array,
      default: []
    }
  },

  data () {
    return {
      value: []
    }
  },
  created () {
    this.value = this.selected == null ? [] : this.selected.map(index => this.options[index])
  },
  watch: {
    options () {
      // options changed! must clear all selected values
      // as we have no idea what's really to select!
      this.value = []
    }
  },
  methods: {
    /**
     * Called when the value of selected changes, firing the input event
     *
     * @param {Object} selectedItems - list contianing selected items (objects)
     */
    onChange (selectedItems) {
      this.$emit('change', selectedItems)
    }
  }
}
</script>


<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<!-- Cannot add "scoped" attribute to limit CSS to this component only 
- this is a limitation of vue-multiselect, we can do hacks but better is to add parent class and make own styles-->
<style lang="scss">
@import "../assets/sass/shared.scss";
@import "../assets/sass/main.scss";
.app_select_multiple {
  // unfortunately I have to override default value, 
  // multiselect adds own style and we need to update it
  height: auto !important;
  .multiselect {
    height: auto;
    min-height: 0;
  }
  .multiselect__select {
    // display: none;
  }
  .multiselect__tags {
    // based on our default input style
    @extend .input;
    height: auto;
  }
  .multiselect__option.multiselect__option {
    color: $primary-text-color;
  }
  .multiselect__tag {
    background-color: $primary-button-background;
    margin-bottom: 0;
  }
  .multiselect__placeholder,
  .multiselect--active .multiselect__placeholder  {
    margin: 0;
    padding: 0;
    display: inline-block;
  }
  .multiselect__tag-icon {
    &:after {
      color: $primary-button-color;
    }
    &:hover {
      background-color: $primary-button-hover-background;
    }
  }
  .multiselect__option.multiselect__option--highlight {
    background-color: $primary-button-background;
    color: $primary-button-color;
  }
}

.app_select_multiple.placeholder {
  .multiselect__placeholder {
    color: $primary-text-color;
  }
}
</style>